import styled from 'styled-components'

export const CardWrapper = styled.div`
  /* padding-top: 43px; */
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  /* height: 60vh; */

  h1 {
    color: ${({ theme }) => theme.colors.navyBlue};
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-size: ${({ theme }) => theme.fontSize.xl};
    font-weight: 600;

    /* line-height: 140%; */
  }
  .manage_text {
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.contestPrimary};
    margin: 0;
  }

  h2 {
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 29px;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.dark};
  }

  /* debit card style */

  /* .debit_card_container {
    height: 40vh;
  } */

  .debit_card_wrapper {
    display: flex;
    height: 60px;
    padding: 7px 10px;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    border-bottom: 1px solid #f2f2f2;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }

    .debit_card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: white;
      /* width: 50%; */
    }
    .card_img {
      width: 48px;
      height: 40px;
      border-radius: 6px;
    }

    .card_num_date {
      margin-left: 20px;
    }
    .card_num {
      color: ${({ theme }) => theme.colors.navyBlue};
      font-size: ${({ theme }) => theme.fontSize.x5};
      font-weight: 500;
      margin: 0;
      padding-bottom: 7px;
    }

    .card_date {
      color: ${({ theme }) => theme.colors.contestPrimary};
      font-size: ${({ theme }) => theme.fontSize.x5};
      font-weight: 500;
      margin: 0;
    }

    .card_arrow {
      margin-right: 10px;
    }

    /* debit card style */

    .delete_card {
      text-align: center;
      .delete_text {
        color: ${({ theme }) => theme.colors.red};
      }
    }

    p {
      color: ${({ theme }) => theme.colors.dark};
      font-size: ${({ theme }) => theme.fontSize.x6};
    }
  }

  h2 {
    color: ${({ theme }) => theme.colors.white};
  }
  h5 {
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 29px;
    letter-spacing: 0.05em;
    color: ${({ theme }) => theme.colors.white};
    margin-top: -5px;
  }
  span {
    font-family: ${({ theme }) => theme.fontFamily.Mulish};
    font-style: normal;
    font-weight: 600;
    font-size: 6px;
    line-height: 8px;
    color: ${({ theme }) => theme.colors.white};
  }

  .cards {
    /* overflow-y: scroll; */
    height: 67vh;
    margin-top: 20px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      height: 500px;
    }
  }

  .confirm {
    margin-bottom: 10px;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
    /* margin-top: 50px ; */
  }

  .no_card_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5rem;
  }
`

export const DeletBCardWrapper = styled.div`
  padding: 30px;

  .delete_card_container {
    margin-top: 4rem;
  }
  .card-detail {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .card-title-text {
    color: ${({ theme }) => theme.colors.dark};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .card-title {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.dark};
  }

  .center {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    p {
      color: ${({ theme }) => theme.colors.red};
      margin-top: 20px;
      cursor: pointer;
    }
  }
  .card {
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: center;
  }
`
